import { Component, OnInit, Renderer, ViewChild } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { AccessControlService } from 'src/app/services/access-control.service';
import { environment } from 'src/environments/environment';
// declare var $: any;
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-system-modules',
  templateUrl: './system-modules.component.html',
  styleUrls: ['./system-modules.component.css']
})
export class SystemModulesComponent implements OnInit {
  serverUrl: String = environment.serverUrl;
  model: any = {};
  id: any;
  systemmoduleList: any = [];
  application: any = [];
  application_name: any;
  noData: any;
  displayedColumns: string[] = ['module_display_name', 'module_description', 'section', 'Actions'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isLoading:boolean;
  dataSource: MatTableDataSource<any>;
  constructor(private authService: AuthService,
    private alertService: AlertService,
    private accesscontrolService: AccessControlService,
    private renderer: Renderer,
    private router: Router,
    private activatedRoute: ActivatedRoute, private toastrService: ToastrService) {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.getModules();
  }

  ngOnInit() {
    this.application_name = this.activatedRoute.snapshot.queryParams['appname'];
  }

  getModulebyApplication_Id() {
    this.accesscontrolService.getModulebyApplication_Id(this.id).subscribe((res) => {
    }, error => { },
      () => {
      })
  }
  getapplicationbyId() {
    this.accesscontrolService.getapplicationbyId(this.id).subscribe((res) => {
      this.application = res;
      this.application_name = this.application.application_name;
    }, error => {
      console.log(error)
    },
      () => {

      })
  }
  //register User
  addModule() {
    this.accesscontrolService.addsystemModule(this.model).subscribe((res) => {

    }, error => { },
      () => {
        this.alertService.updateAlert("Module Added Successfully");
        this.router.navigate(['/system-module-listing'])
      })
  }
  getModules() {
    this.isLoading=true
    this.accesscontrolService.getModulebyApplication_Id(this.id).subscribe(
      (res: any) => {
        this.dataSource = new MatTableDataSource<any>(res.rows);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading=false
     },
     (err)=>{this.isLoading=false}
    );
  }
  delete(id: any) {
    Swal({
      title: 'Are you sure you want to delete?',
      text: "You won't be able to revert this!",
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.accesscontrolService.deletesystemModule(id, this.id).subscribe((res) => {
          this.getModules();
          this.toastrService.success("Module deleted successfully.");
        }, error => {

          this.toastrService.error("Something went wrong.." + error);
        },
          () => {
          })
      }

    })
  }


  addSubmodule(action: any) {
    this.router.navigate(['section-listing'], { queryParams: { id: action, app_id: this.id }, queryParamsHandling: "merge" });
  }
  addRoute() {
    this.router.navigate(['add-system-module'], { queryParams: { opt: 'add', app_id: this.id }, queryParamsHandling: "merge" });
  }
  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
